import LogoEpp from "../icons/logo-epp.svg";
import React, { forwardRef } from "react";
import PreviewBar from "./preview-bar";

const HeaderEpp = forwardRef(({ siteTitle }, ref) => {
  return (
    <div ref={ref} className="header header--epp">
      {process.env.EDIT_MODE === "true" && <PreviewBar />}

      <div className="header__top">
        <div className="container-fluid wrapper">
          <div className="row">
            <div className="col-4">
              <div className="logo text-center">
                <LogoEpp />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default HeaderEpp;
